import { EVOtherEntitiesPageContent } from 'components/eventView/pages/EVOtherEntitiesPageContent';
import { EmbedListHeader } from 'pages/custom/embed/EmbedListHeader';
import { useContext } from 'react';
import { CtxEventView } from 'session/ctxEventView';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    entityDefinitionId: string;
    contentRef?: React.RefCallback<HTMLDivElement>;
}

export const EmbedListPage = (props: Props): JSX.Element => {
    const ctxEventView = useContext(CtxEventView);

    const entityDefinition = ctxEventView.otherEntityDefinitions.find(
        (e) => e.id === props.entityDefinitionId
    );

    return (
        <S_EmbedListPage className={props.className} ref={props.contentRef}>
            <S_EmbedListHeader entityDefinition={entityDefinition} />
            <EVOtherEntitiesPageContent align={'center'} entityId={entityDefinition.id} />
        </S_EmbedListPage>
    );
};

const S_EmbedListPage = styled.div`
    width: 100%;
    padding-top: 30px;
    max-width: 1100px;
    margin: 0 auto;
    position: relative;
`;

const S_EmbedListHeader = styled(EmbedListHeader)`
    margin: -10px 0 20px 0;
    padding-top: 60px;
    padding-bottom: 30px;
`;
